import React, { useId } from 'react';
import type { SvgIconProps } from '@mui/material';

interface GradientIconProps {
  children: React.ReactElement<SvgIconProps>;
  gradientColors?: [string, string];
}

const GradientIcon: React.FC<GradientIconProps> = ({ 
  children, 
  gradientColors = ['#2563EB', '#7C3AED'],
}) => {
  // useId generates a unique ID to avoid conflicts when multiple gradient icons are on the page.
  const gradientId = useId();

  // Clone the icon to apply the gradient fill via inline styles.
  const iconWithGradient = React.cloneElement(children, {
    ...children.props,
    style: { ...children.props.style, fill: `url(#${gradientId})` },
  });

  return (
    <>
      {/* This SVG is not rendered visibly. It just holds the gradient definition. */}
      <svg width="0" height="0" style={{ position: 'absolute' }}>
        <defs>
          <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor={gradientColors[0]} />
            <stop offset="100%" stopColor={gradientColors[1]} />
          </linearGradient>
        </defs>
      </svg>
      {iconWithGradient}
    </>
  );
};

export default GradientIcon; 